import { render } from "./History.vue?vue&type=template&id=6dce3cac&scoped=true"
const script = {}

import "./History.vue?vue&type=style&index=0&id=6dce3cac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dce3cac"]])

export default __exports__